module.exports = __webpack_public_path__ + "202408221624/img/img_popup_01_bg.27be1797.png";